import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-463cdc92"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-header-skeleton__title" };
const _hoisted_2 = { class: "audience-header-skeleton__input" };
const _hoisted_3 = { class: "audience-header-skeleton__filters" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceHeaderSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createBlock(_component_base_card_v2, { class: "audience-header-skeleton" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(SkeletonLoader, {
                            height: "16px",
                            width: "130px"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(SkeletonLoader, { width: "330px" })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(SkeletonLoader, {
                            height: "16px",
                            width: "180px"
                        }),
                        _createVNode(SkeletonLoader, {
                            height: "16px",
                            width: "110px",
                            class: "audience-header-skeleton__spaced"
                        }),
                        _createVNode(SkeletonLoader, {
                            height: "16px",
                            width: "150px"
                        })
                    ])
                ]),
                _: 1
            }));
        };
    }
});
